module.exports = __webpack_public_path__ + "img/6.962dd915.jpg";